import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/business',
  component: Layout,
  redirect: '/business',
  name: 'business',
  meta: {
    title: '业务',
    icon: 'business',
  },
  children: [
    // {
    //     path: 'year_frame',
    //     name: 'yearFrameIndex',
    //     component: () => import('@/views/business/year_frame.vue'),
    //     meta: {
    //         title: '年框管理',
    //         breadcrumb: true,
    //         auth: [
    //             'Business.YearFrame.menu'
    //         ]
    //     }
    // },
    // {
    //   path: 'year_frame/detail/:id',
    //   name: 'yearFrameDetail',
    //   component: () => import('@/views/business/year_frame_detail.vue'),
    //   meta: {
    //     title: '年框详情',
    //     menu: false,
    //     activeMenu: '/business/year_frame',
    //     auth: [
    //         'Business.YearFrame.menu'
    //     ]
    //   },
    // },
    {
        path: 'index',
        name: 'businessIndex',
        component: () => import('@/views/business/index.vue'),
        meta: {
            title: '业务管理',
            breadcrumb: true,
            auth: [
                'Business.Business.menu'
            ]
        }
    },
    {
      path: 'detail/:id',
      name: 'businessDetail',
      component: () => import('@/views/business/detail.vue'),
      meta: {
        title: '业务详情',
        menu: false,
        activeMenu: '/business/index',
        auth: [
            'Business.Business.menu'
        ]
      },
    },
    {
        path: 'supplemental',
        name: 'supplementalIndex',
        component: () => import('@/views/business/supplemental.vue'),
        meta: {
            title: '补充协议',
            breadcrumb: true,
            auth: [
                'Business.Supplemental.menu'
            ]
        }
    },
    {
      path: 'supplemental/detail/:id',
      name: 'supplementalDetail',
      component: () => import('@/views/business/supplemental_detail.vue'),
      meta: {
        title: '补充协议详情',
        menu: false,
        activeMenu: '/business/supplemental',
        auth: [
            'Business.Supplemental.menu'
        ]
      },
    },
    {
        path: 'invoicing',
        name: 'businessInvoicing',
        component: () => import('@/views/business/invoicing.vue'),
        meta: {
            title: '发票管理',
            breadcrumb: true,
            auth: [
                'Business.Invoicing.menu'
            ]
        }
    }
  ],
}

export default routes
